import { IFreelancer } from "../data_models/freelancer";

export function getFreelancerName(freelancer: IFreelancer): string {
    if (!freelancer || (!freelancer.firstName && !freelancer.lastName)) {
        return 'New Freelancer';
    }
    let name = `${freelancer.firstName} ${freelancer.middleName} ${freelancer.lastName}`;
    // remove extra spaces
    name = name.replace(/\s+/g, ' ').trim();
    return name;
}